import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Admitir el Miedo, Sin Vergüenza",
    opening: localizedGenderNode(
      [
      "Hoy no me obligo a empezar. Admito: hay miedo en mí."
    ],
      [
      "Hoy no me obligo a empezar. Admito: hay miedo en mí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Este miedo intenta protegerme”."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Este miedo intenta protegerme”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué es exactamente lo que me asusta al pensar en una cita o en una nueva conexión?\n[Escribe aquí]",
      "¿Qué pensamiento se repite cuando imagino comenzar?\n[Escribe aquí]",
      "¿Dónde siento este miedo en mi cuerpo?\n[Escribe aquí]"
    ],
      [
      "¿Qué es exactamente lo que me asusta al pensar en una cita o en una nueva conexión?\n[Escribe aquí]",
      "¿Qué pensamiento se repite cuando imagino comenzar?\n[Escribe aquí]",
      "¿Dónde siento este miedo en mi cuerpo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El miedo no es fracaso. Es una señal."
    ],
      [
      "Cierre",
      "El miedo no es fracaso. Es una señal."
    ]
    ),
    action: localizedGenderNode(
      "Cuando surjan pensamientos sobre citas — una respiración + “Ahora solo estoy escuchando”.",
      "Cuando surjan pensamientos sobre citas — una respiración + “Ahora solo estoy escuchando”."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Lo Que Temo Que Vean en Mí",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo a ser visto/a."
    ],
      [
      "Hoy toco el miedo a ser visto/a."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué temo que descubran de mí en una cita?\n[Escribe aquí]",
      "¿Qué parte de mí se siente “no suficiente”?\n[Escribe aquí]",
      "¿Quién me enseñó que esto debía ocultarse?\n[Escribe aquí]"
    ],
      [
      "¿Qué temo que descubran de mí en una cita?\n[Escribe aquí]",
      "¿Qué parte de mí se siente “no suficiente”?\n[Escribe aquí]",
      "¿Quién me enseñó que esto debía ocultarse?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El miedo a mostrarse nació para proteger."
    ],
      [
      "Cierre",
      "El miedo a mostrarse nació para proteger."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una cualidad que suelo ocultar — sin juzgarla.",
      "Escribo una cualidad que suelo ocultar — sin juzgarla."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "La Presión de Ser “Algo”",
    opening: localizedGenderNode(
      [
      "Hoy observo la presión de actuar."
    ],
      [
      "Hoy observo la presión de actuar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué papel siento que debo interpretar en una cita?\n[Escribe aquí]",
      "¿Qué pasaría si no lo interpretara?\n[Escribe aquí]",
      "¿Cómo reacciona mi cuerpo ante la idea de “impresionar”?\n[Escribe aquí]"
    ],
      [
      "¿Qué papel siento que debo interpretar en una cita?\n[Escribe aquí]",
      "¿Qué pasaría si no lo interpretara?\n[Escribe aquí]",
      "¿Cómo reacciona mi cuerpo ante la idea de “impresionar”?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La conexión no comienza con actuación. Comienza con presencia."
    ],
      [
      "Cierre",
      "La conexión no comienza con actuación. Comienza con presencia."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy — noto cuando me esfuerzo por ser algo.",
      "Una vez hoy — noto cuando me esfuerzo por ser algo."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Recuerdos de Citas Pasadas",
    opening: localizedGenderNode(
      [
      "Hoy separo pasado de presente."
    ],
      [
      "Hoy separo pasado de presente."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué experiencia pasada aún vive en mi cuerpo?\n[Escribe aquí]",
      "¿Qué temo que vuelva a ocurrir?\n[Escribe aquí]",
      "¿Qué es diferente en mí hoy respecto a entonces?\n[Escribe aquí]"
    ],
      [
      "¿Qué experiencia pasada aún vive en mi cuerpo?\n[Escribe aquí]",
      "¿Qué temo que vuelva a ocurrir?\n[Escribe aquí]",
      "¿Qué es diferente en mí hoy respecto a entonces?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El pasado explica — no controla."
    ],
      [
      "Cierre",
      "El pasado explica — no controla."
    ]
    ),
    action: localizedGenderNode(
      "Me digo: “Esto es un recuerdo, no una profecía”.",
      "Me digo: “Esto es un recuerdo, no una profecía”."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Miedo al Rechazo",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo a escuchar “no”."
    ],
      [
      "Hoy toco el miedo a escuchar “no”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué significa el rechazo sobre mí en mi mente?\n[Escribe aquí]",
      "¿Dónde aprendí que el rechazo significa que hay algo mal en mí?\n[Escribe aquí]",
      "¿Cuál es una verdad más suave?\n[Escribe aquí]"
    ],
      [
      "¿Qué significa el rechazo sobre mí en mi mente?\n[Escribe aquí]",
      "¿Dónde aprendí que el rechazo significa que hay algo mal en mí?\n[Escribe aquí]",
      "¿Cuál es una verdad más suave?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El rechazo no define el valor."
    ],
      [
      "Cierre",
      "El rechazo no define el valor."
    ]
    ),
    action: localizedGenderNode(
      "Cuando surge el miedo — mano en el pecho + una respiración.",
      "Cuando surge el miedo — mano en el pecho + una respiración."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "El Cuerpo y las Citas",
    opening: localizedGenderNode(
      [
      "Hoy escucho a mi cuerpo, no lucho contra él."
    ],
      [
      "Hoy escucho a mi cuerpo, no lucho contra él."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué hace mi cuerpo cuando imagino una cita?\n[Escribe aquí]",
      "¿Qué sensación es la más fuerte?\n[Escribe aquí]",
      "¿Qué necesita mi cuerpo de mí ahora?\n[Escribe aquí]"
    ],
      [
      "¿Qué hace mi cuerpo cuando imagino una cita?\n[Escribe aquí]",
      "¿Qué sensación es la más fuerte?\n[Escribe aquí]",
      "¿Qué necesita mi cuerpo de mí ahora?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El cuerpo habla el lenguaje de la protección."
    ],
      [
      "Cierre",
      "El cuerpo habla el lenguaje de la protección."
    ]
    ),
    action: localizedGenderNode(
      "Tres respiraciones profundas cuando aparece tensión.",
      "Tres respiraciones profundas cuando aparece tensión."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Por Qué Quiero una Relación",
    opening: localizedGenderNode(
      [
      "Hoy vuelvo a la intención."
    ],
      [
      "Hoy vuelvo a la intención."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Por qué quiero una relación? (no por qué “debo”)\n[Escribe aquí]",
      "¿Qué sensación estoy buscando?\n[Escribe aquí]",
      "¿Qué intención suave pongo para mí?\n[Escribe aquí]"
    ],
      [
      "¿Por qué quiero una relación? (no por qué “debo”)\n[Escribe aquí]",
      "¿Qué sensación estoy buscando?\n[Escribe aquí]",
      "¿Qué intención suave pongo para mí?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La intención suaviza el miedo."
    ],
      [
      "Cierre",
      "La intención suaviza el miedo."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una intención y la llevo conmigo.",
      "Escribo una intención y la llevo conmigo."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Bajar el Ritmo",
    opening: localizedGenderNode(
      [
      "Hoy suelto la presión de apresurarme."
    ],
      [
      "Hoy suelto la presión de apresurarme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Quién dijo que debo apresurarme?\n[Escribe aquí]",
      "¿Qué ocurre en mí cuando imagino un ritmo lento?\n[Escribe aquí]",
      "¿Qué alivio hay en eso?\n[Escribe aquí]"
    ],
      [
      "¿Quién dijo que debo apresurarme?\n[Escribe aquí]",
      "¿Qué ocurre en mí cuando imagino un ritmo lento?\n[Escribe aquí]",
      "¿Qué alivio hay en eso?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un ritmo lento es seguro."
    ],
      [
      "Cierre",
      "Un ritmo lento es seguro."
    ]
    ),
    action: localizedGenderNode(
      "Me recuerdo: “Ir despacio está permitido”.",
      "Me recuerdo: “Ir despacio está permitido”."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Límites en una Cita",
    opening: localizedGenderNode(
      [
      "Hoy recuerdo que puedo poner límites."
    ],
      [
      "Hoy recuerdo que puedo poner límites."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué límite es importante para mí en una cita?\n[Escribe aquí]",
      "¿Qué miedo aparece si lo pongo?\n[Escribe aquí]",
      "¿Cómo me protege un límite?\n[Escribe aquí]"
    ],
      [
      "¿Qué límite es importante para mí en una cita?\n[Escribe aquí]",
      "¿Qué miedo aparece si lo pongo?\n[Escribe aquí]",
      "¿Cómo me protege un límite?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Los límites crean seguridad."
    ],
      [
      "Cierre",
      "Los límites crean seguridad."
    ]
    ),
    action: localizedGenderNode(
      "Formulo un límite para mí.",
      "Formulo un límite para mí."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "No Toda Conexión Debe Funcionar",
    opening: localizedGenderNode(
      [
      "Hoy suelto la idea de “destino”."
    ],
      [
      "Hoy suelto la idea de “destino”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué presión pongo en cada nuevo encuentro?\n[Escribe aquí]",
      "¿Qué pasaría si solo fuera un encuentro, nada más?\n[Escribe aquí]",
      "¿Cómo se siente eso en mi cuerpo?\n[Escribe aquí]"
    ],
      [
      "¿Qué presión pongo en cada nuevo encuentro?\n[Escribe aquí]",
      "¿Qué pasaría si solo fuera un encuentro, nada más?\n[Escribe aquí]",
      "¿Cómo se siente eso en mi cuerpo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un encuentro no es un examen de vida."
    ],
      [
      "Cierre",
      "Un encuentro no es un examen de vida."
    ]
    ),
    action: localizedGenderNode(
      "Me digo: “Es solo un encuentro”.",
      "Me digo: “Es solo un encuentro”."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Ser Yo, Incluso con Miedo",
    opening: localizedGenderNode(
      [
      "Hoy no espero a no tener miedo."
    ],
      [
      "Hoy no espero a no tener miedo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Quién soy cuando simplemente soy yo?\n[Escribe aquí]",
      "¿Qué pasa si el miedo está y aun así soy yo?\n[Escribe aquí]",
      "¿Qué alivio hay en eso?\n[Escribe aquí]"
    ],
      [
      "¿Quién soy cuando simplemente soy yo?\n[Escribe aquí]",
      "¿Qué pasa si el miedo está y aun así soy yo?\n[Escribe aquí]",
      "¿Qué alivio hay en eso?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El coraje es ser — no desaparecer."
    ],
      [
      "Cierre",
      "El coraje es ser — no desaparecer."
    ]
    ),
    action: localizedGenderNode(
      "Me permito ser natural.",
      "Me permito ser natural."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Confianza Gradual",
    opening: localizedGenderNode(
      [
      "Hoy recuerdo que la confianza se construye despacio."
    ],
      [
      "Hoy recuerdo que la confianza se construye despacio."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me asusta de confiar?\n[Escribe aquí]",
      "¿Cuál es la diferencia entre confianza total y confianza pequeña?\n[Escribe aquí]",
      "¿Qué pequeña confianza es posible para mí?\n[Escribe aquí]"
    ],
      [
      "¿Qué me asusta de confiar?\n[Escribe aquí]",
      "¿Cuál es la diferencia entre confianza total y confianza pequeña?\n[Escribe aquí]",
      "¿Qué pequeña confianza es posible para mí?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La confianza no salta — camina."
    ],
      [
      "Cierre",
      "La confianza no salta — camina."
    ]
    ),
    action: localizedGenderNode(
      "Ofrezco una pequeña confianza.",
      "Ofrezco una pequeña confianza."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Elegir un Movimiento Suave",
    opening: localizedGenderNode(
      [
      "Hoy elijo movimiento, no un salto."
    ],
      [
      "Hoy elijo movimiento, no un salto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pequeño paso se siente posible?\n[Escribe aquí]",
      "¿Qué miedo rodea ese paso?\n[Escribe aquí]",
      "¿Qué me fortalece de él?\n[Escribe aquí]"
    ],
      [
      "¿Qué pequeño paso se siente posible?\n[Escribe aquí]",
      "¿Qué miedo rodea ese paso?\n[Escribe aquí]",
      "¿Qué me fortalece de él?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El progreso no tiene que doler."
    ],
      [
      "Cierre",
      "El progreso no tiene que doler."
    ]
    ),
    action: localizedGenderNode(
      "Doy solo un pequeño paso.",
      "Doy solo un pequeño paso."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre Suave del Viaje",
    opening: localizedGenderNode(
      [
      "Hoy resumo sin presión."
    ],
      [
      "Hoy resumo sin presión."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre mi miedo?\n[Escribe aquí]",
      "¿Qué se fortaleció en mí?\n[Escribe aquí]",
      "Frase de regreso para días estresantes:\n[Escribe aquí]"
    ],
      [
      "¿Qué aprendí sobre mi miedo?\n[Escribe aquí]",
      "¿Qué se fortaleció en mí?\n[Escribe aquí]",
      "Frase de regreso para días estresantes:\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del viaje",
      "No tengo que apresurarme para ser digno/a de amor.",
      "Puedo moverme a mi propio ritmo.",
      "Con miedo — y conmigo.",
      "Y eso es fortaleza."
    ],
      [
      "Cierre final del viaje",
      "No tengo que apresurarme para ser digno/a de amor.",
      "Puedo moverme a mi propio ritmo.",
      "Con miedo — y conmigo.",
      "Y eso es fortaleza."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que honra mi ritmo.",
      "Una acción que honra mi ritmo."
    ),
  },
].map(buildNormalizedDay);

export const fearStartingRelationshipDatingAnxietyBlueprintEs = buildNormalizedPilotBlueprint({
  id: "fear_starting_relationship_dating_anxiety_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "fear_starting_relationship_dating_anxiety",
  category: "general",
  journeyName: {
    he: "פחד להתחיל קשר (דייטים מלחיצים)",
    en: "Fear of Starting a Relationship (Dating Anxiety)",
    es: "Miedo a Iniciar una Relación (Citas que Generan Ansiedad)",
  },
  days,
});

export default fearStartingRelationshipDatingAnxietyBlueprintEs;
